import * as api from "../../shared/api";
import * as biz_data_helper from "../../shared/biz_data_helper";
import * as _date from "date-fns";

const content_type = "TEC_RouteSpoilageStdTBL";

const create = function () {
  return {
    content_type: "muji",
    age: 29
  };
};
const descriptor = {};

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
);

const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: { width: "60px" }
    },
    { key: 'dataAreaId', label: '公司', sortable: true },
    { key: "RouteType", label: "工序类型", sortable: true },
    { key: "ColorNumber", label: "色组数", sortable: true },
    { key: 'SpoilageBaseNumber', label: '加放基数', sortable: true },
    { key: 'SpoilageRate', label: '加放率', sortable: true },
    { key: 'StartNumber', label: '起始数', sortable: true },
    { key: 'EndNumber', label: '结束数', sortable: true },

  ]
};

const dataForm = {};

///前端验证
const rules = {};
const methods = {
  ///get
  async getData(_params) {
    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields.default, "key")
      })
      .run();

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data;
    } else {
      return null;
    }
  }
};
export { fields, dataForm, methods, rules, biz_data };
